import { render } from "./CollectionsView.vue?vue&type=template&id=ea4ce80e"
import script from "./CollectionsView.vue?vue&type=script&lang=js"
export * from "./CollectionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__